module.exports = __webpack_public_path__ + "static/media/1.90df37a9.jpg";